"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealtimeType = void 0;
var RealtimeType;
(function (RealtimeType) {
    RealtimeType[RealtimeType["Empty"] = 0] = "Empty";
    RealtimeType[RealtimeType["Campaign"] = 1] = "Campaign";
    RealtimeType[RealtimeType["Event"] = 2] = "Event";
    RealtimeType[RealtimeType["Item"] = 3] = "Item";
    RealtimeType[RealtimeType["Pageview"] = 4] = "Pageview";
    RealtimeType[RealtimeType["Screenview"] = 5] = "Screenview";
    RealtimeType[RealtimeType["Segment"] = 6] = "Segment";
    RealtimeType[RealtimeType["Transaction"] = 7] = "Transaction";
    RealtimeType[RealtimeType["Visitorevent"] = 8] = "Visitorevent";
    RealtimeType[RealtimeType["Latencytracking"] = 9] = "Latencytracking";
    RealtimeType[RealtimeType["Nps"] = 10] = "Nps";
    RealtimeType[RealtimeType["Taglatencytracking"] = 11] = "Taglatencytracking";
    RealtimeType[RealtimeType["Performance"] = 12] = "Performance";
    RealtimeType[RealtimeType["Datalayer"] = 13] = "Datalayer";
    RealtimeType[RealtimeType["Batch"] = 14] = "Batch";
})(RealtimeType = exports.RealtimeType || (exports.RealtimeType = {}));
//# sourceMappingURL=types.js.map